import { defineMessages } from 'react-intl';

const scope = 'evaluable';

export default defineMessages({
  defaultError: {
    id: `${scope}.error.default`,
    defaultMessage: 'An unknown error occurred',
  },
});
